
<div>
    <p class="page-title">Material State</p>
    <div class="section-wrapper tabletab">
      <np-tabbed>
        <ul class="tabs">
          <li role="tab" (click)="changeNav()" aria-selected="true">Manage Material State</li>
          <li role="tab" aria-selected="false">Add Material State</li>
        </ul>  <div class="tab-content" role="tabpanel" aria-hidden="false">
          <div class="mt-10 mb-10">
            <div class="exportBtnContainer">
              <button (click)="exportToExcel()" class="primary-btn">Export To Excel</button>
            </div>
            <div >
            <p-table
              [value]="materialData"
              [scrollable]="true"
              scrollHeight="400px"
              [virtualRowHeight]="20"
              styleClass="division-table p-datatable-gridlines"
            id="StyleTable"
            >
            <ng-template pTemplate="header">
              <tr>
                <th >Material State</th>
                <th >Status</th>
                <th >Action To Take</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.MaterialStateName }}</td>
                <td >{{ row.status }}</td>
                <td class="text-center">
                  <button [ngClass]="row.buttonName =='Retire'?'btn-success': 'btn-warning'" (click)="retire(row)">{{ row.buttonName }}</button>
                </td>
              </tr>
            </ng-template>
            </p-table>
          </div>
          </div>
        </div>
  
  
        <div class="tab-content" role="tabpanel" aria-hidden="true">
          <p class="boldOne">
            Ability to add a new material state to the Operations user interface.</p>
            <p class="errorText" *ngIf="errorData">Please enter required fields.</p>
            <p class="errorText" *ngIf="SaveSuccess">The item has been successfully added.</p>
          
          <div class="manage-details-container">
            <div class="section-title boldOne">Enter Material State Data</div>
            <div class="partioned-table">
              <div class="row">
                <div class="cell label">Material State</div>
                <div class="cell value d-flex">
                  <input [(ngModel)]="newMaterialState" maxlength="12" />
                  <p class="errorText">  * Required </p>
  
                </div>
              </div>
              <div class="row">
                  <div class="cell label">Listing Priority</div>
                  <div class="cell value d-flex">
                    <input
                    [(ngModel)]="ListingPriority"
                    type="number"
                    (input)="onInput($event)"
                    maxlength="3"
                  />
                  <p class="errorText">  * Required</p>
                  </div>
                </div>
              <div class="row">
                  <div class="cell label"></div>
                  <div class="cell value">
                    <p-button label="Add New Material State"  styleClass="primary-btn"  (click)="addMaterialState()"></p-button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </np-tabbed>
    </div>
  </div>
  